var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { SignalWatcher } from '@lit-labs/signals';
import { firebaseAuthState, userAdminState, loadUsers, setUserRoles, clearUserAdminError, } from '@df/state';
let UserAdminAppShell = class UserAdminAppShell extends SignalWatcher(LitElement) {
    static styles = css `
    :host {
      display: block;
      width: 100%;
    }

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 2rem 1rem;
    }

    .header {
      margin-bottom: 2rem;
    }

    .title {
      font-size: 2rem;
      font-weight: 700;
      color: #1f2937;
      margin: 0 0 0.5rem 0;
    }

    .subtitle {
      font-size: 1rem;
      color: #6b7280;
      margin: 0;
    }

    .error {
      padding: 1rem;
      background-color: #fee2e2;
      border: 1px solid #fca5a5;
      border-radius: 6px;
      color: #991b1b;
      margin-bottom: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .error-close {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 1.25rem;
      color: #991b1b;
    }

    .loading {
      text-align: center;
      padding: 4rem 2rem;
      color: #9ca3af;
      font-size: 1.125rem;
    }
  `;
    hasRequestedUsers = false;
    constructor() {
        super();
        this.selectedUser = null;
        this.isRolePickerOpen = false;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        const { authState, authUser } = firebaseAuthState.get();
        if (authState === 'authenticated' && authUser && !this.hasRequestedUsers) {
            this.hasRequestedUsers = true;
            loadUsers().catch((error) => {
                console.error('Failed to load users:', error);
            });
        }
        else if ((!authUser || authState !== 'authenticated') && this.hasRequestedUsers) {
            this.hasRequestedUsers = false;
        }
    }
    handleUserSelected(event) {
        this.selectedUser = {
            uid: event.detail.uid,
            email: event.detail.email,
            roles: event.detail.currentRoles,
        };
        this.isRolePickerOpen = true;
    }
    async handleRolesSelected(event) {
        if (!this.selectedUser)
            return;
        try {
            if (event.detail.selectedRoles.length > 0) {
                await setUserRoles(this.selectedUser.uid, event.detail.selectedRoles);
            }
            this.isRolePickerOpen = false;
            this.selectedUser = null;
        }
        catch (error) {
            console.error('Failed to update user roles:', error);
        }
    }
    handleCancel() {
        this.isRolePickerOpen = false;
        this.selectedUser = null;
    }
    render() {
        // Make component reactive to auth changes
        firebaseAuthState.get();
        const { users, loading, error } = userAdminState.get();
        return html `
      <div class="container">
        <div class="header">
          <h1 class="title">User Administration</h1>
          <p class="subtitle">Manage user roles and permissions</p>
        </div>

        ${error
            ? html `
              <div class="error">
                <span>${error}</span>
                <button class="error-close" @click=${() => clearUserAdminError()}>
                  ×
                </button>
              </div>
            `
            : ''}

        ${loading
            ? html ` <div class="loading">Loading users...</div> `
            : html `
              <df-user-admin-list
                .users=${users}
                .loading=${loading}
                @user-selected=${(e) => this.handleUserSelected(e)}
              ></df-user-admin-list>
            `}

        <df-role-picker
          ?open=${this.isRolePickerOpen}
          .userEmail=${this.selectedUser?.email || ''}
          .currentRoles=${this.selectedUser?.roles || []}
          @roles-selected=${(e) => this.handleRolesSelected(e)}
          @cancel=${() => this.handleCancel()}
        ></df-role-picker>
      </div>
    `;
    }
};
__decorate([
    state()
], UserAdminAppShell.prototype, "selectedUser", void 0);
__decorate([
    state()
], UserAdminAppShell.prototype, "isRolePickerOpen", void 0);
UserAdminAppShell = __decorate([
    customElement('user-admin-app-shell')
], UserAdminAppShell);
export { UserAdminAppShell };
//# sourceMappingURL=user-admin-app-shell.js.map